import { Position } from "@staffedupusa/shared-components";

export const getPositionStatusDescription = (status: 1 | 2 | 3 | 4) => {
    let desc;

    switch (status) {
        case 1:
            desc = 'Closed';
            break;
        case 2:
            desc = 'Accepting Applications';
            break;
        case 3:
            desc = 'Now Hiring';
            break;
        case 4:
            desc = 'Archive';
            break;
        /* c8 ignore next */
        default:
    }

    return desc;
};
  
export const formSalaryString = ({
    s_salary,
    s_salary_max,
    tips,
    bonus,
    incentives,
    benefits,
    commission,
    s_pay_frequency
}: Position) => {
    const salary = [s_salary, s_salary_max]
        .filter(Boolean)
        .map((val) => `$${val}`)
        .join(' - ');

    let salaryString = s_salary ? `${salary} / ${s_pay_frequency}` : 'Compensation is not specified';

    if (tips) {
        salaryString += ' + tips';
    }

    if (commission) {
        salaryString += ' + commission';
    }
    if (bonus) {
        salaryString += ' + bonus';
    }
    if (incentives) {
        salaryString += ' + incentives';
    }
    if (benefits) {
        salaryString += ' + benefits';
    }
    return salaryString;
};
  